/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyClientTachographCardReader
 */
export interface ReadOnlyClientTachographCardReader {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClientTachographCardReader
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientTachographCardReader
     */
    cardReaderSn: string;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyClientTachographCardReader
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClientTachographCardReader
     */
    client?: number | null;
}

export function ReadOnlyClientTachographCardReaderFromJSON(json: any): ReadOnlyClientTachographCardReader {
    return ReadOnlyClientTachographCardReaderFromJSONTyped(json, false);
}

export function ReadOnlyClientTachographCardReaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyClientTachographCardReader {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardReaderSn': json['card_reader_sn'],
        'activeTo': !exists(json, 'active_to') ? undefined : (json['active_to'] === null ? null : new Date(json['active_to'])),
        'client': !exists(json, 'client') ? undefined : json['client'],
    };
}

export function ReadOnlyClientTachographCardReaderToJSON(value?: ReadOnlyClientTachographCardReader | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'card_reader_sn': value.cardReaderSn,
        'active_to': value.activeTo === undefined ? undefined : (value.activeTo === null ? null : value.activeTo.toISOString()),
        'client': value.client,
    };
}


